import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// bridge--theme: tells the native shell which theme the user chose in Settings → Appearance.
//
// The choice lives in the WebView's localStorage, which native chrome (toolbar, tab bar,
// drawer, status bar) can't see — so without this, "Dark" in the app on a phone set to Light
// gives dark pages inside light chrome. Sends { theme: "light" | "dark" | "system" } when the
// page connects, and again as "change" whenever theme_controller.js saves a new choice.
// The shell applies it app-wide and remembers it for the next cold start.
//
// Only runs inside Hotwire Native (BridgeComponent no-ops in a normal browser). Pairs with
// ThemeComponent.kt in the Android repo.
export default class extends BridgeComponent {
  static component = "theme"

  connect() {
    super.connect()
    this.send("connect", { theme: this.#stored() })

    this.onChange = (event) => this.send("change", { theme: event.detail.theme })
    window.addEventListener("theme:change", this.onChange)
  }

  disconnect() {
    window.removeEventListener("theme:change", this.onChange)
    super.disconnect()
  }

  #stored() {
    return localStorage.getItem("theme") || "system"
  }
}
